import styled from 'styled-components';

export const StyledErrorPopup = styled.div`
  max-width: 30vw;
  min-width: 25rem;

  .error-popup-title-holder {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 12px;
    width: 100%;
  }

  .error-popup-logo {
    width: 24px;
    height: 24px;
  }

  .error-popup-title {
    font-family: "NeueMachina";
    font-size: 1.5em;
    line-height: 1.2;
    font-weight: 800;
    color: white;
    text-transform: uppercase;
  }

  .error-popup-description {
    font-family: "NeueMachina";
    font-size: 1rem;
    line-height: 1.4rem;
  }

  .error-popup-content {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 24px;
    flex-direction: column;
    gap: 24px;
  }

  .error-popup-button-holder {
    display: flex;
    flex-direction: row;
    justify-content: center;

    div {
      max-width: 30%;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    max-width: 90vw;
    min-width: 90vw;
  }
`;
